var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('v-divider'),_c('h2',{staticClass:"pa-4"},[_vm._v(_vm._s(_vm.title))]),_c('v-divider')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }